import server from "../Server";
import withErrorCheck from "../CheckError";
import { GetPlayerGroupsPayload } from '@grassrootly/api/gateways/player/GetPlayerGroups';
import { IGroup } from '@grassrootly/api/entities';

export const GetPlayerGroups = async (payload: GetPlayerGroupsPayload): Promise<IGroup[]> => {
  if (!payload.playerId) {
    return [];
  }
  const groupMappers = withErrorCheck(
    await server.from("GroupPlayers").select("group_id").eq("player_id", payload.playerId)
  );
  const groups = withErrorCheck(
    await server
      .from("Groups")
      .select("*")
      .in(
        "id",
        groupMappers.map((g) => g.group_id)
      )
  );

  return groups;
};
